import React from "react";
import ReactDOM from "react-dom";
import { Provider as ReduxProvider } from "react-redux";
import { ApolloProvider } from "react-apollo";
import { ConnectedRouter } from "connected-react-router/immutable";
import { ThemeProvider } from "react-css-themr";
import { config as startRaven } from "@lifepay/redux-subsystem-handle-error";
import theme from "@lifepay/ui-theme-crimson-gold";

import store, { history } from "./model/store";
import client from "./model/client";

import App from "./containers/App";

startRaven({
  key: "",
});

theme.init.use();

const Root = () => (
  <ReduxProvider store={store}>
    <ConnectedRouter history={history}>
      <ApolloProvider client={client}>
        <ThemeProvider theme={theme.classes}>
          <App />
        </ThemeProvider>
      </ApolloProvider>
    </ConnectedRouter>
  </ReduxProvider>
);

ReactDOM.render(<Root />, document.getElementById("root"));

if (module.hot) {
  module.hot.accept("./containers/App", () => {
    ReactDOM.render(<Root />, document.getElementById("root"));
  });
}



// WEBPACK FOOTER //
// ./src/index.js